"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var Utilities_1 = require("../../Utilities");
var TextField_base_1 = require("./TextField.base");
var TextField_styles_1 = require("./TextField.styles");
exports.TextField = (0, Utilities_1.styled)(TextField_base_1.TextFieldBase, TextField_styles_1.getStyles, undefined, {
    scope: 'TextField',
});
//# sourceMappingURL=TextField.js.map